module.exports = __webpack_public_path__ + "static/img/gxg_04.0fadce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gxg_img/gxg_04.png
// module id = VzOk
// module chunks = 46